import { connect } from 'react-redux';

import {
  editPaymentDetails,
  loadUserSubscription,
  setEditPaymentDetailsMessage,
  setEditPaymentDetailsSuccess,
} from '../../actions/accountSettingsAction';
import {
  activateSubscription,
  cancelSubscription,
  changeSubscription,
  renewSubscription,
  resetComponent,
  revertCancellation,
  setCancelSubscriptionMessage,
  setCancelSubscriptionSuccess,
  setRefundAmountMessage,
  setRevertCancellationMessage,
  setRevertCancellationSuccess,
  setSubscriptionOperationMessage,
  setSubscriptionOperationSuccess,
  switchSubscriptionToStripe,
  updateSubscriptionPlan,
  upgradeSubscription,
} from '../../actions/manageSubscriptionActions';
import { checkCoupon, loadPlans } from '../../actions/signUpActions';
import {
  getContentByReference,
  loadQuestionsSKTCounter,
} from '../../actions/studyMainActions';
import { getLoggedStudent } from '../../actions/userActions';
import {
  getEditPaymentDetailsMessage,
  getEditPaymentDetailsSuccess,
  getEditPaymentDetailsWaiting,
  getLoadingUserSubscription,
  getUserSubscription,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import ManageSubscriptionPage from '../../components/ManageSubscription/ManageSubscriptionPage';
import {
  getCancelSubscriptionMessage,
  getCancelSubscriptionSuccess,
  getCancelSubscriptionWaiting,
  getRefundAmountMessage,
  getRevertCancellationMessage,
  getRevertCancellationSuccess,
  getRevertCancellationWaiting,
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
  getSubscriptionOperationMessage,
  getSubscriptionOperationSuccess,
  getSubscriptionOperationWaiting,
  getUpdateSubscriptionPlanMessage,
  getUpdateSubscriptionPlanSuccess,
  getUpdateSubscriptionPlanWaiting,
} from '../../components/ManageSubscription/ManageSubscriptionSelectors';
import { getCoupon, getPlans } from '../../components/SignUp/SignUpSelectors';
import {
  getContentByRefSelector,
  getIsLoadingSktData,
  getQuestionSKTCount,
} from '../../components/Study/studyMainSelectors';
import { getUser } from '../../components/User/userSelectors';
import { verifyLoggedUser } from '../../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  loadingUserSubscription: getLoadingUserSubscription(state),
  editPaymentDetailsWaiting: getEditPaymentDetailsWaiting(state),
  editPaymentDetailsSuccess: getEditPaymentDetailsSuccess(state),
  editPaymentDetailsMessage: getEditPaymentDetailsMessage(state),
  cancelSubscriptionWaiting: getCancelSubscriptionWaiting(state),
  cancelSubscriptionSuccess: getCancelSubscriptionSuccess(state),
  cancelSubscriptionMessage: getCancelSubscriptionMessage(state),
  revertCancellationWaiting: getRevertCancellationWaiting(state),
  revertCancellationSuccess: getRevertCancellationSuccess(state),
  revertCancellationMessage: getRevertCancellationMessage(state),
  plans: getPlans(state),
  subscriptionOperationWaiting: getSubscriptionOperationWaiting(state),
  subscriptionOperationSuccess: getSubscriptionOperationSuccess(state),
  subscriptionOperationMessage: getSubscriptionOperationMessage(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  updateSubscriptionPlanMessage: getUpdateSubscriptionPlanMessage(state),
  updateSubscriptionPlanWaiting: getUpdateSubscriptionPlanWaiting(state),
  updateSubscriptionPlanSuccess: getUpdateSubscriptionPlanSuccess(state),
  couponCheck: getCoupon(state),
  refundAmountMessage: getRefundAmountMessage(state),
  contentByRef: getContentByRefSelector(state),
  questionsSKTCount: getQuestionSKTCount(state),
  isLoadingSktData: getIsLoadingSktData(state),
});

const mapDispatchToProps = (dispatch) => ({
  activateSubscription: () => {
    dispatch(activateSubscription());
  },
  loadUserSubscription: () => dispatch(loadUserSubscription()),
  loadQuestionsSKTCounter: (rateId, rank, dutyState) =>
    dispatch(loadQuestionsSKTCounter(rateId, rank, dutyState)),
  editPaymentDetails: (subscriptionId, details) =>
    dispatch(editPaymentDetails(subscriptionId, details)),
  setEditPaymentDetailsMessage: (message) =>
    dispatch(setEditPaymentDetailsMessage(message)),
  setEditPaymentDetailsSuccess: (value) =>
    dispatch(setEditPaymentDetailsSuccess(value)),
  cancelSubscription: (subscriptionId, message) =>
    dispatch(cancelSubscription(subscriptionId, message)),
  setCancelSubscriptionMessage: (message) =>
    dispatch(setCancelSubscriptionMessage(message)),
  setCancelSubscriptionSuccess: (value) =>
    dispatch(setCancelSubscriptionSuccess(value)),
  loadPlans: () => dispatch(loadPlans()),
  revertCancellation: (subscriptionId) =>
    dispatch(revertCancellation(subscriptionId)),
  setRevertCancellationMessage: (message) =>
    dispatch(setRevertCancellationMessage(message)),
  setRevertCancellationSuccess: (value) =>
    dispatch(setRevertCancellationSuccess(value)),
  switchSubscriptionToStripe: (switchSubscription) =>
    dispatch(switchSubscriptionToStripe(switchSubscription)),
  renewSubscription: (newSubscription) =>
    dispatch(renewSubscription(newSubscription)),
  setSubscriptionOperationMessage: (message) =>
    dispatch(setSubscriptionOperationMessage(message)),
  setSubscriptionOperationSuccess: (value) =>
    dispatch(setSubscriptionOperationSuccess(value)),
  resetComponent: () => {
    dispatch(resetComponent());
    dispatch(getLoggedStudent());
  },
  changeSubscription: (id, subscription) =>
    dispatch(changeSubscription(id, subscription)),
  upgradeSubscription: (newSubscription) =>
    dispatch(upgradeSubscription(newSubscription)),
  verifyLoggedUser: () => verifyLoggedUser(),
  updateSubscriptionPlan: (planId) => {
    dispatch(updateSubscriptionPlan(planId));
  },
  checkCoupon: (coupon, planId, isTrialUser, userId) =>
    dispatch(checkCoupon(coupon, planId, isTrialUser, userId)),
  setRefundAmountMessage: (message) =>
    dispatch(setRefundAmountMessage(message)),
  getByReference: (rate) => {
    dispatch(getContentByReference(rate));
  },
});

const ManageSubscriptionPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageSubscriptionPage);

export default ManageSubscriptionPageContainer;
